/**
 * Administración de usuarios, roles y permisos.
 *
 * El alta es PREVIA al login: el acceso con Google solo funciona si el email ya
 * existe. Desactivar (`estado = inactivo`) es la forma normal de retirar el
 * acceso conservando el rastro del usuario.
 *
 * Store Pinia: estado compartido del módulo y orquestación de sus servicios.
 * Las vistas no llaman a `http` ni a los servicios directamente; pasan por aquí.
 * Los servicios no lanzan, así que las acciones interpretan valores neutros
 * (`[]`, `null`, `false`) como fallo.
 */

import { defineStore } from 'pinia'
import type { Usuario } from '@/interfaces/Usuario'
import { http } from '@/services/http'

/** Store `usuarios`. Ver la cabecera del archivo para el contrato del módulo. */
export const useGestionUsuarios = defineStore('usuarios', {
  state: () => ({
    usuarioActual: null as Usuario | null,
  }),

  actions: {
    async me(): Promise<Usuario | null> {
      const result = await http.get<Usuario>('/api/me')
      if (result.ok && result.data) {
        this.usuarioActual = result.data
      }
      return this.usuarioActual
    },
  }
})
